import React, {useEffect,useState} from 'react';
import {FormValidator, useFormValidator, Inputs, useTariffableInputs} from 'coaz-ui';
import client from '../client';

const EditUserType = ({params, submitRef, setLoading, setEnableSubmit}) => {
	const [userType,setUserType] = useState(null);
	const minWidth = 240;
	const {request,errorMessage} = client;

	const submit = async (e) => {
		try {
			const response = await request("PUT","user-types", userType);

			if (response && response.ref) {
				return {
					message: 'Successful',
					success: true
				};
			}

			return {
				message: errorMessage(response)
			};
		} catch (error) {
			return {
				message: errorMessage(error)
			};
		}
	};

	const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

	const {inputs} = useTariffableInputs(userType,setUserType,request,handleChange,register,errors);

	useEffect(() => {
		if (handleSubmit) {
			submitRef.current = { submit: handleSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		return () => {
			submitRef.current = null;
		};
	}, [handleSubmit]);

	useEffect(() => {
		( async () => {
			if(!params || !params.id) return;
			setLoading && setLoading(true);
			let usrType = null;
			await request('GET',`user-types/${params.id}`)
			.then((response) => {
				if(response && response.ref) {
					usrType = response;
				}
			})
			.catch((error) => {
				console.log(error);
			})
			
			setUserType(usrType);
			setLoading && setLoading(false);
		}
		)();
	},[]);

	return (
		<FormValidator>
			<div className='flex flex-col w-full h-auto'>
				<div className='flex flex-col w-full h-auto space-y-4 shrink-0'>
					<Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
				</div>
			</div>
		</FormValidator>
	  )
}

export default EditUserType